import { toastStore } from 'shared/ui'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { PaygLimitModalStore } from 'entities/Subscription/ui/PaygLimitModal'
import { GoToQuestionnaireModalStore } from 'pages/settings/pages/compliance/ui/GoToQuestionnaireModal'
import { CANCELED_SUBSCRIPTION_TOAST } from 'pages/settings/lib/canceledSubscriptionToast'

function shouldOpenQuestionnaire(entities: IEntitiesStore): boolean {
  const isRestricted = entities.subscriptionStore.isTrial || entities.subscriptionStore.isPAYGPlan

  if (entities.usersStore.user?.isUKCountry) return false

  return (
    isRestricted &&
    !entities.organizationStore.isTwilioNumberVendor &&
    Boolean(entities.usersStore.user?.isRequireNumber)
  )
}

function shouldOpenPaygLimitModal(entities: IEntitiesStore): boolean {
  return entities.subscriptionStore.isPAYGPlan && !entities.usersStore.user?.isRequireNumber
}

type IRunBeforeAddMemberOptions = {
  checkCanceled?: boolean
  skipLimits?: boolean
}

export function runBeforeAddMember(
  entities: IEntitiesStore,
  onProceed: () => void,
  options: IRunBeforeAddMemberOptions = {}
): void {
  const { checkCanceled = true, skipLimits = false } = options

  if (checkCanceled && entities.subscriptionStore.isCanceled) {
    toastStore.add(CANCELED_SUBSCRIPTION_TOAST)
    return
  }

  if (!skipLimits) {
    if (shouldOpenQuestionnaire(entities)) {
      new GoToQuestionnaireModalStore(entities).open('members')
      return
    }

    if (shouldOpenPaygLimitModal(entities)) {
      new PaygLimitModalStore(entities).open('members')
      return
    }
  }

  onProceed()
}
